import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';

const AdminEventManagement = () => {
  const navigate = useNavigate(); const eventMenuItems = [
    { title: 'crea nuovo evento', icon: 'bi-calendar-plus', path: '/admin/events/create' },
    { title: 'visualizza eventi', icon: 'bi-calendar-week', path: '/admin/events/list' },
    { title: 'gestisci partecipanti', icon: 'bi-people-fill', path: '/admin/events/list?showParticipants=true' },
  ];
  return (
    <div className="container-fluid min-vh-100" style={{ background: 'linear-gradient(135deg, #006e39, #52b788)' }}>
      <div className="row p-2 p-md-4">
        <div className="col-12">
          <div className="glass-container p-3 p-md-4 rounded-4" style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-2">
              <button 
                onClick={() => navigate('/admin')} 
                className="btn btn-link p-0 text-decoration-none"
                style={{ color: '#006e39' }}
                title="Torna alla dashboard"
              >
                <i className="bi bi-arrow-left-circle fs-5"></i>
              </button>
              <h1 style={{ color: '#006e39' }} className="mb-0 fs-3 fs-md-1">Gestione Eventi</h1>
            </div>
            <p style={{ color: '#2b6a4e' }} className="mb-5">Gestisci tutti i tuoi eventi, creane di nuovi o visualizza quelli esistenti.</p>

            <div className="row g-4">
              {eventMenuItems.map((item, index) => (
                <div key={index} className="col-md-6 col-lg-4">
                  <div className="glass-card p-4 rounded-4 text-center h-100 d-flex flex-column align-items-center justify-content-center"
                    style={{
                      background: 'rgba(255, 255, 255, 0.9)',
                      border: '1px solid #006e39',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease'
                    }}
                    onClick={() => navigate(item.path)}
                  >
                    <i className={`bi ${item.icon} fs-1 mb-3`} style={{ color: '#006e39' }}></i>
                    <h3 className="fs-5 mb-0" style={{ color: '#006e39' }}>{item.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminEventManagement;
